import { RedirectLoginResult } from '@auth0/auth0-spa-js'
import { IRedirectLoginAppState } from '@/retail/contexts/user/domain/IRedirectLoginAppState'
import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class RetrieveAccessTokenAfterLogin {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<RedirectLoginResult<IRedirectLoginAppState>> {
    return this.authenticationRepository.handleRedirect()
  }
}
